import { Marker, Popup } from 'react-map-gl/mapbox';
import dipositIcon from '../../../assets/diposit.png'; // Asegúrate de que la ruta sea correcta
import './CannonStationMarker.css';
import CannonAction from './CannonAction'; // Asegúrate de que la ruta sea correcta
import { useMap } from 'react-map-gl/mapbox';

import clockIcon from '../../../assets/clock.png';
import CannonChannel from './CannonChannels';
import CoordinatesLink from '../Base/CoordinatesLink';

const CannonStationMarker = ({ data , isActive , onActivate , onDeactivate, can, zeusAvailable }) => {
  const { current: map } = useMap();



  return (
  <>
    <Marker 
      longitude={data.location.longitude} latitude={data.location.latitude}
      className="cannon-station-marker"
      >
      <img
        onClick={(e) => {
          e.stopPropagation();
          map.easeTo({
                            center: [data.location.longitude, data.location.latitude],
                            offset: [0, -130], // desplaza el mapa hacia arriba
                            duration: 500,
                        });
          onActivate(); }} // Abre el popup al hacer clic
        src={dipositIcon} alt="Water Diposit" className='cannon-station-marker-image' />
    </Marker>
    {isActive && (
        <Popup
            longitude={data.location.longitude}
            latitude={data.location.latitude}
            onClose={onDeactivate}
            closeOnClick={true}
            anchor="top"
            maxWidth='450px'
        >
          <div style={{ fontFamily: "'Inter', sans-serif", maxWidth: '450px', minWidth: '150px' }} >
            {!zeusAvailable && (
              <div style={{ background: '#fff3cd', border: '1px solid #ffc107', borderRadius: 4, padding: '4px 8px', marginBottom: 8, fontSize: 12, color: '#856404' }}>
                Monitorización no disponible
              </div>
            )}
            <h3 style={{ marginBottom: '4px', fontSize: '14px' }}>Depósito </h3>
            <span style={{ fontSize: '24px' }}>{data.name}</span>
            {can(['cannon-manager','admin']) && (
            <div style={{ marginTop: '8px', marginLeft: '40px', textAlign: 'right', float: 'right' }}>
              {data.actions.map(action => (
                <CannonAction key={action.actionId} stationId={data.stationId} stationName={data.name} action={action} zeusAvailable={zeusAvailable} />
              ))}
              


            </div>
            )}
            <div style={{ marginTop: '8px' }}>
              {data.channels.map(channel => (
                <CannonChannel key={channel.channelId} channel={channel} zeusAvailable={zeusAvailable} />
              ))}
            </div>
            <CoordinatesLink latitude={data.location.latitude} longitude={data.location.longitude} />
            <p style={{ alignItems: 'center', gap: '5px' }}>
                <img src={clockIcon} alt='clock' style={{ height: '15px', width: '15px'}}/> {zeusAvailable ? new Date(data.lastConnection).toLocaleString('es-ES') : '—'}
            </p>
          </div>
        </Popup>
    )}
  </>
)};

export default CannonStationMarker;